import { render, staticRenderFns } from "./StatusOrderPill.vue?vue&type=template&id=7ea5f7c8&"
import script from "./StatusOrderPill.vue?vue&type=script&lang=js&"
export * from "./StatusOrderPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports